<template>
  <div class="pages">
    <div class="moileLogin">
      <img src="../../assets/img/cloudLogo.png" alt class="logo" />
      <p>请输入手机号提取：</p>
      <div class="inputBg">
        <input type="text" placeholder="请输入手机号提取" @change="getPhone"/>
      </div>
      <div class="upBtn" @click="extract">提取作品</div>
    </div>
  </div>
</template>

<script>
import { obtain } from "@/request/api";
import { Message } from "element-ui";

export default {
  name: "mobileLogin",
  data() {
    return {
      phoneValue: ""
    };
  },
   methods: {
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 获取手机号
    getPhone(event) {
      this.phoneValue = event.srcElement.value;
    },
    // 点击提取
    extract() {
      var that = this;
      var params = {
        code: that.phoneValue
      };
      obtain(params).then(res => {
        console.log(res, "登录成功");
        if (res.data.data.length != 0) {
          that.$router.push({
            path: "/mobileClient",
            query: {
              id: that.phoneValue
            }
          });
        } else {
          Message.error("该手机号没有绑定项目，请修改手机号");
        }
      });
    }
  },
  mounted() {
    console.log(this._isMobile);
    if (this._isMobile()) {
      // alert("手机端");
      // this.$router.push({
      //   path: "/mobileLogin"
      // });
    } else {
      // alert("pc端");
       this.$router.push({
        path: "/customerLogin"
      });
    }
  }

};
</script>

<style lang="less" scoped>
.pages {
  width: 100vw;
  height: 100vh;
  background-image: url(../../assets/img/loginBack.jpg);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .moileLogin {
    width: 318px;
    background: #ffffff;
    background: rgba(255, 255, 255, 1);
    box-shadow: 5px 5px 20px 0px rgba(182, 182, 182, 0.14);
    border-radius: 10px;
    padding: 18px 16px;
    box-sizing: border-box;
    text-align: center;
    .logo {
      margin-bottom: 28px;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: left;
      margin-bottom: 17px;
    }
    .inputBg {
      width: 282px;
      height: 45px;
      background: #f6f6f6;
      border-radius: 20px;
      padding-left: 20px;
      box-sizing: border-box;
      text-align: left;
      line-height: 45px;
      input {
        background: #f6f6f6;
        border: none;
      }
      input:focus {
        outline: none;
      }
      input::-webkit-input-placeholder {
        color: #c9c9c9;
        font-size: 14px;
      }
    }
    .upBtn {
      width:282px;
      height: 40px;
      background: #000;
      line-height: 40px;
      border-radius: 20px;
      color: #ffffff;
      margin-top: 34px;
    }
  }
}
</style>